<template>
      <TheFooter fixed>
        <div>
          <!--footer-->
          Copyright &copy;&nbsp;<a href="http://optage.co.jp/" target="_blank">OPTAGE Inc.</a>
        </div>
        <div class="ml-auto">
          <span class="mr-1">Powered by</span>
          <a href="https://optage.co.jp/business/service/iot/" target="_blank">OPTAGE IoT Platform</a>
        </div>
      </TheFooter>
</template>
<script>
import { Footer as TheFooter } from '@coreui/vue'
export default {
  name: 'DefaultFooter',
  components: {
    TheFooter
  }
}
</script>
